export const staticLabelsSearch = {
  en: {
    searchResultsFor: "Search Results for",
    searchResults: "Search Results",
  },
  th: {
    searchResultsFor: "ผลลัพธ์ของการค้นหาสำหรับ",
    searchResults: "ผลลัพธ์ของการค้นหา",
  },
};
